import React from 'react';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';

const BubbleFeature = (props) => {
  const sizeMap = {
    large: '280px',
    medium: '240px',
  };

  const imageSizeMap = {
    large: '200px',
    medium: '120px',
  };

  const lineHeightMap = {
    large: '2.0rem',
    medium: '1.5rem',
  };

  const fontSizeMap = {
    large: '1.0rem',
    medium: '0.75rem',
  };

  return (
    <SbEditable content={props.blok}>
      <Bubble size={sizeMap[props.blok.size]}>
        <BImage size={imageSizeMap[props.blok.size]} image={props.blok.image.filename} />
        <BTitle>{props.blok.title}</BTitle>
        <BText lineHeight={lineHeightMap[props.blok.size]} fontSize={fontSizeMap[props.blok.size]}>
          {props.blok.text}
        </BText>
      </Bubble>
    </SbEditable>
  );
};

const Bubble = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${(props) => props.size};
`;

const BImage = styled.div`
  height: ${(props) => props.size};
  width: ${(props) => props.size};
  border-radius: 50%;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
`;

const BTitle = styled.h2`
  line-height: 1.2;
  font-size: 1.5rem;
  font-weight: 600;
  padding-top: 0.5rem;
`;

const BText = styled.span`
  line-height: ${(props) => props.lineHeight};
  font-size: ${(props) => props.fontSize};
`;

export default BubbleFeature;
